import React from 'react';
import { TabNavigationContainer, TabButton } from './TabNavigation.styled';
import { ASSETS } from '../../../utils/config';
import ImagesIcon from '../../../assets/icons/Hotbar/ImagesIcon';
import VideosIcon from '../../../assets/icons/Hotbar/VideosIcon';
import AudiosIcon from '../../../assets/icons/Hotbar/AudiosIcon';
import DocumentsIcon from '../../../assets/icons/Hotbar/DocumentsIcon';
import LinksIcon from '../../../assets/icons/Hotbar/LinksIcon';
// const { ImagesIcon, VideosIcon, DocumentsIcon, AudiosIcon, LinksIcon_hotbar } = ASSETS;

const TabNavigation = ({ activeTab, onChangeTab }) => {
  const tabs = [
    {
      id: 'images',
      label: 'Images',
      icon: (
        <ImagesIcon
          fill={activeTab === 'images' ? '#9B5AF8' : '#4A4458'}
          style={{ marginLeft: '2px', marginTop: '10px', marginRight: '-5px' }}
        />
      ),
    },
    {
      id: 'videos',
      label: 'Videos',
      icon: (
        <VideosIcon
          fill={activeTab === 'videos' ? '#9B5AF8' : '#4A4458'}
          style={{ marginLeft: '2px', marginTop: '10px', marginRight: '-5px' }}
        />
      ),
    },
    {
      id: 'audios',
      label: 'Audios',
      icon: (
        <AudiosIcon
          fill={activeTab === 'audios' ? '#9B5AF8' : '#4A4458'}
          style={{ marginLeft: '2px', marginTop: '8px', marginRight: '-5px' }}
        />
      ),
    },
    {
      id: 'documents',
      label: 'Documents',
      icon: (
        <DocumentsIcon
          fill={activeTab === 'documents' ? '#9B5AF8' : '#4A4458'}
          style={{ marginLeft: '2px', marginTop: '8px', marginRight: '-5px' }}
        />
      ),
    },
    {
      id: 'links',
      label: 'Links',
      icon: (
        <LinksIcon
          fill={activeTab === 'links' ? '#9B5AF8' : '#4A4458'}
          style={{ marginLeft: '2px', marginTop: '8px', marginRight: '-5px' }}
        />
      ),
    },
  ];

  return (
    <TabNavigationContainer>
      {tabs.map((tab) => (
        <TabButton key={tab.id} isActive={activeTab === tab.id} onClick={() => onChangeTab(tab.id)}>
          {/* <img src={tab.icon} alt={`${tab.label} icon`} /> */}
          {tab.icon}
          {activeTab === tab.id && <span>{tab.label}</span>}
        </TabButton>
      ))}
    </TabNavigationContainer>
  );
};

export default TabNavigation;
